import React from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAllBuyManagers } from '@/store/slices/buyManager/buyManagers';

interface BuyManagerSelectProps {
  value: string | number;
  onChange: (event: SelectChangeEvent) => void;
  disabled?: boolean;
  minWidth?: number;
}

/**
 * BuyManager selection dropdown component
 * @param {BuyManagerSelectProps} props - Component props
 * @returns {JSX.Element} BuyManagerSelect component
 */
export default function BuyManagerSelect({ value, onChange, disabled = false, minWidth = 200 }: BuyManagerSelectProps) {
  const buyManagers = useSelector(selectAllBuyManagers);

  return (
    <FormControl sx={{ minWidth }}>
      <Select
        value={value.toString() || ''}
        onChange={onChange}
        size="small"
        variant="outlined"
        disabled={disabled}
      >
        {buyManagers?.slice()
          .sort((a: any, b: any) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`))
          .map((buyManager: any) => (
            <MenuItem key={buyManager.buyManagerID} value={buyManager.buyManagerID}>
              {`${buyManager.firstName} ${buyManager.lastName}`}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
